module.exports = __webpack_public_path__ + "static/media/YM90_5.d92af748.jpg";